export default {
    SERVICE_SERVER_ERROR: 'ទិន្នន័យ​មិន​ត្រឹមត្រូវ។',
    BAD_REQUEST: 'ខុស។ ព្យាយាម​ម្តង​ទៀត',
    DNS_RECORD_EXIST: 'មានកំណត់ត្រា',
    EMPTY_DATA: 'គ្មានទិន្នន័យទេ។',
    NAMESERVER_EXIST: 'ឈ្មោះម៉ាស៊ីនមេ មានរួចហើយ',
    EMAIL_FORWARDING_RECORD_EXIST: 'អ៊ីមែលបញ្ជូនបន្តមានរួចហើយ',
    EMAIL_TYPE_NOT_SUPPORT: 'អ៊ីមែលមិនត្រឹមត្រូវ',
    EMAIL_FORWARDING_MAX: 'កំណត់ត្រាអតិបរមា',
    EMAIL_FORWARDING_NOT_EXIST: 'អ៊ីមែលបញ្ជូនបន្តមិនមានទេ។',
    DNS_NOT_FOUND: 'គ្មានកំណត់ត្រា។',
    EMAIL_EXISTS: 'អ៊ីមែលមានរួចហើយ',
    CLOUD_SERVER_SETTING_UP:
        'មិនអាចផ្លាស់ប្តូរប្រព័ន្ធប្រតិបត្តិការបានទេ ពេលដែលម៉ាស៊ីនមេកំពុងដំឡើង',
    AMOUNT_EXCEEDED_LIMIT: 'សមតុល្យមិនគ្រប់គ្រាន់សម្រាប់ការដកប្រាក់ទេ។',
    NAMESERVER_INCORRECT: 'ឈ្មោះម៉ាស៊ីនមេ មិន​ត្រឹមត្រូវ។',
    SMS_TEMPLATE_NOT_FOUND: 'រកមិនឃើញគំរូ សារ SMS',
    BRAND_NAME_EXISTED: 'ឈ្មោះម៉ាកមានរួចហើយ',
    BALANCE_NOT_ENOUGH: 'សមតុល្យរបស់អ្នកមិនគ្រប់គ្រាន់ទេ។',
    SMS_TRANSACTION_NOT_FOUND: 'រកមិនឃើញប្រតិបត្តិការទេ។',
    REFUND_NOT_FOUND: 'ការធ្វើប្រតិបត្តិការសងដោយដៃរបស់អ្នករកមិនឃើញ',
    CANT_SET_TEMPLATE: 'មិនអាចកំណត់គំរូបានទេ',
    SERVICE_UNAVAILABLE_TO_RENEW: 'េវាកម្មមិនអាចបន្តបាន',
    SHARED_HOSTING_NOT_FOUND: 'ការ​ចែករំលែក Hosting មិនត្រូវបានរកឃើញទេ',
    CLOUD_HOSTING_IS_DELETED: 'Cloud hosting ត្រូវបានលុប',
    CLOUD_HOSTING_IS_STOPPED: 'Cloud hosting ត្រូវបានបញ្ឈប់',
    CLOUD_HOSTING_IS_SUSPENDED: 'Cloud hosting ត្រូវបានផ្អាក',
    CLOUD_SERVER_IS_DELETED: 'Cloud server ត្រូវបានលុប',
    CLOUD_SERVER_IS_SUSPENDED: 'Cloud Server ត្រូវបានផ្អាក',
    PRIMARY_DOMAIN_NOT_AVAILABLE:
        'វាត្រូវបានភ្ជាប់ជាមួយ Cloud Hosting ឬ Shared Hosting ផ្សេងទៀត',
    INCORRECT_OTP: 'លេខកូដ OTP មិនត្រឹមត្រូវទេ។',
    CLOUD_HOSTING_NOT_FOUND: 'Cloud Hosting រកមិនឃើញ',
    CLOUD_SERVER_NOT_FOUND: 'រកមិនឃើញ Cloud Server',
    SERVICE_CAN_NOT_UPGRADE: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    ADDON_IS_REQUIRED: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    PACKAGE_NOT_FOUND: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    PACKAGE_MUST_BE_HIGHER: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    ADDON_MUST_BE_HIGHER: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    DURATION_IS_REQUIRED: 'មិនអាចធ្វើបច្ចុប្បន្នភាពCloud Serviceបានទេ',
    CARD_NOT_FOUND: 'រកមិនឃើញកាត',
    CAN_NOT_DELETE_CARD: 'កាតមិនអាចលុបបានទេ',
    EMAIL_SETTING_NOT_FOUND: 'រកមិនឃើញការកំណត់អ៊ីមែលនេះទេ',
    EMAIL_TYPE_INVALID: 'ប្រភេទការកំណត់អ៊ីមែលមិនត្រឹមត្រូវ',
    CARD_NOT_ACCEPTED:
        'កាតនេះមិនត្រូវបានទទួលយកទេ។ យើង មិន ទទួល យក កាត ដោយ មិន បាន បើក Secure (3DS) ទេ។',
    BRAND_NAME_IS_NOT_ASSIGNED: 'Brandname នេះមិនមែនជារបស់គណនីអ្នកទៀតទេ',
    SMS_SCHEDULE_INCORRECT: 'រកមិនឃើញកាលវិភាគ SMS ទេ',
    INVOICE_VAT_NOT_FOUND: 'វិក្កយបត្រ VAT នេះរកមិនឃើញទេ',
    PHONE_EXISTS:
        'លេខ ទូរសព្ទ នេះ ត្រូវ បាន ផ្ទេរកម្មសិទិ្ធ ទៅ អ្នក ប្រើ ផ្សេង រួច ហើយ។',
    CARD_DECLINED: {
        AUTHENTICATION_REQUIRED:
            'កាតត្រូវបានបដិសេធ ដោយសារប្រតិបត្តិការតម្រូវឱ្យមានការផ្ទៀងផ្ទាត់អោយបានត្រឹមត្រូវ។',
        APPROVE_WITH_ID: 'ការទូទាត់មិនត្រូវបានអនុញ្ញាត។',
        CALL_ISSUER: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        CARD_NOT_SUPPORTED: 'កាតមិនអនុញ្ញាតការទិញប្រភេទនេះទេ។',
        CARD_VELOCITY_EXCEEDED:
            'អតិថិជនបានលើសសមតុល្យ ឬកម្រិតឥណទានដែលមាននៅលើកាតរបស់ពួកគេ។',
        CURRENCY_NOT_SUPPORTED: 'កាតមិនគាំទ្ររូបិយប័ណ្ណដែលបានបញ្ជាក់ទេ។',
        DO_NOT_HONOR: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        DO_NOT_TRY_AGAIN: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        DUPLICATE_TRANSACTION:
            'ប្រតិបត្តិការដែលមានចំនួនទឹកប្រាក់ដូចគ្នា និងព័ត៌មានកាតឥណទានត្រូវបានដាក់ជូននាពេលថ្មីៗនេះ។',
        EXPIRED_CARD: 'កាតបានផុតកំណត់ហើយ។',
        FRAUDULENT:
            'ការទូទាត់ត្រូវបានបដិសេធ ដោយសារ Stripe សង្ស័យថា វាជាការក្លែងបន្លំ។',
        GENERIC_DECLINE:
            'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ ឬអាចបង្កឡើងដោយច្បាប់ទូទាត់ដែលត្រូវបានរារាំង។',
        INCORRECT_NUMBER: 'លេខ​កាត​មិន​ត្រឹមត្រូវ។',
        INCORRECT_CVC: 'លេខ CVC មិន​ត្រឹមត្រូវ។',
        INCORRECT_PIN:
            'លេខសម្ងាត់ដែលបានបញ្ចូលគឺមិនត្រឹមត្រូវទេ។ លេខកូដបដិសេធនេះអនុវត្តតែចំពោះការទូទាត់ដែលបានធ្វើឡើងជាមួយកម្មវិធីអានកាតប៉ុណ្ណោះ។',
        INCORRECT_ZIP: 'លេខ​កូដ​ប្រៃសណីយ៍​មិន​ត្រឹមត្រូវ។',
        INSUFFICIENT_FUNDS: 'កាតមានថវិកាមិនគ្រប់គ្រាន់ដើម្បីបញ្ចប់ការទិញ។',
        INVALID_ACCOUNT: 'កាត ឬគណនីដែលកាតត្រូវបានភ្ជាប់ទៅ គឺមិនត្រឹមត្រូវទេ។',
        INVALID_AMOUNT:
            'ចំនួនទឹកប្រាក់ទូទាត់មិនត្រឹមត្រូវ ឬលើសពីចំនួនដែលបានអនុញ្ញាត។',
        INVALID_CVC: 'លេខ CVC មិន​ត្រឹមត្រូវ។',
        INVALID_EXPIRY_MONTH: 'ខែផុតកំណត់គឺមិនត្រឹមត្រូវទេ។',
        INVALID_EXPIRY_YEAR: 'ឆ្នាំផុតកំណត់គឺមិនត្រឹមត្រូវទេ។',
        INVALID_NUMBER: 'លេខ​កាត​មិន​ត្រឹមត្រូវ។',
        INVALID_PIN:
            'លេខសម្ងាត់ដែលបានបញ្ចូលគឺមិនត្រឹមត្រូវទេ។ លេខកូដបដិសេធនេះអនុវត្តតែចំពោះការទូទាត់ដែលបានធ្វើឡើងជាមួយកម្មវិធីអានកាតប៉ុណ្ណោះ។',
        ISSUER_NOT_AVAILABLE:
            'មិនអាចទាក់ទងអ្នកចេញកាតបានទេ ដូច្នេះការទូទាត់មិនអាចអនុញ្ញាតបានទេ។',
        LOST_CARD:
            'ការបង់ប្រាក់ត្រូវបានបដិសេធ ដោយសារកាតត្រូវបានរាយការណ៍ថាបាត់។',
        MERCHANT_BLACKLIST:
            'ការបង់ប្រាក់ត្រូវបានបដិសេធ ព្រោះវាត្រូវគ្នានឹងតម្លៃនៅលើបញ្ជីប្លុករបស់អ្នកប្រើ Stripe។',
        NEW_ACCOUNT_INFORMATION_AVAILABLE:
            'កាត ឬគណនីដែលកាតត្រូវបានភ្ជាប់ទៅ គឺមិនត្រឹមត្រូវទេ។',
        NO_ACTION_TAKEN: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        not_permitted: 'ការទូទាត់មិនត្រូវបានអនុញ្ញាតទេ។',
        OFFLINE_PIN_REQUIRED: 'កាត​ត្រូវ​បាន​បដិសេធ​ព្រោះ​វា​ទាមទារ​កូដ PIN។',
        ONLINE_OR_OFFLINE_PIN_REQUIRED:
            'កាតត្រូវបានបដិសេធ ដោយសារវាទាមទារកូដ PIN។',
        PICKUP_CARD:
            'អតិថិជន​មិន​អាច​ប្រើ​កាត​នេះ​ដើម្បី​ធ្វើ​ការ​ទូទាត់​នេះ​បាន​ទេ (វា​អាច​ថា​វា​ត្រូវ​បាន​គេ​រាយការណ៍​ថា​បាត់ ឬ​ត្រូវ​គេ​លួច)។',
        PIN_TRY_EXCEEDED: 'ចំនួននៃការសាកល្បងកូដ PIN ដែលអាចអនុញ្ញាតបានលើស។',
        PROCESSING_ERROR: 'កំហុសបានកើតឡើងនៅពេលដំណើរការកាត។',
        REENTER_TRANSACTION:
            'ការទូទាត់មិនអាចដំណើរការដោយអ្នកចេញដោយមិនដឹងមូលហេតុ។',
        RESTRICTED_CARD:
            'អតិថិជន​មិន​អាច​ប្រើ​កាត​នេះ​ដើម្បី​ធ្វើ​ការ​ទូទាត់​នេះ​បាន​ទេ (វា​អាច​ថា​វា​ត្រូវ​បាន​គេ​រាយការណ៍​ថា​បាត់ ឬ​ត្រូវ​គេ​លួច)។',
        REVOCATION_OF_ALL_AUTHORIZATIONS: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        REVOCATION_OF_AUTHORIZATION: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        SECURITY_VIOLATION: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        SERVICE_NOT_ALLOWED: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        STOLEN_CARD:
            'ការបង់ប្រាក់ត្រូវបានបដិសេធ ដោយសារកាតត្រូវបានរាយការណ៍ថាត្រូវបានគេលួច។',
        STOP_PAYMENT_ORDER: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        TESTMODE_DECLINE: 'លេខកាតសាកល្បង Stripe ត្រូវបានប្រើប្រាស់។',
        TRANSACTION_NOT_ALLOWED: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        TRY_AGAIN_LATER: 'កាតត្រូវបានបដិសេធដោយមិនដឹងមូលហេតុ។',
        WITHDRAWAL_COUNT_LIMIT_EXCEEDED:
            'អតិថិជនបានលើសសមតុល្យ ឬដែនកំណត់ឥណទានដែលមាននៅលើកាតរបស់ពួកគេ។',
    },
    EXPIRED_CARD: 'កាតបានផុតកំណត់ហើយ។ ពិនិត្យកាលបរិច្ឆេទផុតកំណត់ ឬប្រើកាតផ្សេង',
    INCORRECT_CVC:
        'លេខកូដសុវត្ថិភាពរបស់កាតមិនត្រឹមត្រូវទេ។ ពិនិត្យលេខកូដសុវត្ថិភាពរបស់កាត ឬប្រើកាតផ្សេង។',
    PROCESSING_ERROR:
        'កំហុសបានកើតឡើងនៅពេលដំណើរការកាត។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ ឬដោយប្រើវិធីបង់ប្រាក់ផ្សេង។',
    INCORRECT_NUMBER:
        'លេខ​កាត​មិន​ត្រឹមត្រូវ។ សូមពិនិត្យមើលលេខកាត ឬប្រើកាតផ្សេង។',
    ACCOUNT_BANNED: 'គណនីត្រូវបានហាមឃាត់',
    REQUIRED_USERNAME: 'ឈ្មោះអ្នកប្រើត្រឹមត្រូវគឺត្រូវបានទាមទារ',
    REQUIRED_PASSWORD: 'ទាមទារពាក្យសម្ងាត់ត្រឹមត្រូវ',
    USERNAME_PASSWORD_INCORRECT: 'ឈ្មោះអ្នកប្រើនិងពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
    AWS_ACCOUNT_NOT_FOUND: 'មិនឃើញគណនី AWS',
    INVALID_2FA_STATUS: 'ស្ថានភាពមិនត្រឹមត្រូវ',
    WORDPRESS_HOSTING_NOT_AVAILABLE: 'WordPress Hosting មិនអាចប្រើបាន។',
    FAILED_PROGRESS: 'កំហុសបានកើតឡើងអំឡុងពេលដំណើរការ',
    LOCKED_UPDATE_SSL:
        'ប្រព័ន្ធកំពុងដំណើរការការកំណត់រចនាសម្ព័ន្ធ SSL របស់អ្នក។',
    WORDPRESS_HOSTING_NO_SPACE:
        'អ្នកមិនមានកន្លែងគ្រប់គ្រាន់ដើម្បីធ្វើឲ្យការដំឡើងនេះប្រសើរឡើងទេ',
    ORDER_NOT_FOUND: 'រកមិនឃើញការបញ្ជាទិញរបស់អ្នក',
    ORDER_STATUS_INVALID: 'វិក័យប័ត្ររបល់អ្នកត្រូវបានបង់',
    INVOICE_PROCESSED:
        'វិក្កយបត្ររបស់អ្នកកំពុងត្រូវបានដំណើរការ។ អរគុណ​សម្រាប់​ការ​រង់ចាំ​របស់​អ្នក',
    CANNOT_SAVE_PAYMENT_INFO_FOR_ORDER:
        'វិក្កយបត្ររបស់អ្នកកំពុងត្រូវបានដំណើរការ។ អរគុណ​សម្រាប់​ការ​រង់ចាំ​របស់​អ្នក',
    CANNOT_COMPLETE_PAYMENT:
        'សូមព្យាយាមម្តងទៀតនៅពេលក្រោយនៅក្នុងផ្ទាំងគ្រប់គ្រង ផ្នែកវិក្កយបត្រ',
    INVALID_REQUEST_EXCEEDS_AUTH_AMOUNT:
        'ចំនួនទឹកប្រាក់ដែលបានស្នើសុំលើសពីចំនួនដែលបានអនុញ្ញាតដំបូង។ កើតឡើង ជាឧទាហរណ៍',
    PAYMENT_GATEWAY_ERROR:
        'កំហុស {errorCode} សូមព្យាយាមម្តងទៀត ប្រសិនបើវានៅតែកើតឡើង សូមទាក់ទងផ្នែកជំនួយ',
    PAYMENT_PROCESSOR_ERROR:
        'កំហុស {errorCode} សូមព្យាយាមម្តងទៀត ប្រសិនបើវានៅតែកើតឡើង សូមទាក់ទងផ្នែកជំនួយ',
    PARAMETER_INVALID_EMPTY:
        'កំហុស {errorCode} សូមព្យាយាមម្តងទៀត ប្រសិនបើវានៅតែកើតឡើង សូមទាក់ទងផ្នែកជំនួយ',
    DECLINED_EXPIRED_CARD:
        'បដិសេធ - កាតផុតកំណត់។ អ្នកក៏អាចទទួលបានវាផងដែរ ប្រសិនបើកាលបរិច្ឆេទផុតកំណត់ដែលអ្នកបានផ្តល់មិនត្រូវគ្នានឹងកាលបរិច្ឆេទដែលចេញកាតធនាគារមាននៅលើឯកសារ។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_PROCESSOR_DECLINED:
        'បដិសេធ - ការបដិសេធទូទៅនៃកាត។ មិនមានកាផ្តល់ព័ត៌មានបន្ថែមផ្តល់ដោយអ្នកចេញកាតធនាគានោះទេ។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_INSUFFICIENT_FUND:
        'បដិសេធ - ថវិកានៅក្នុងគណនីមិនគ្រប់គ្រាន់។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_STOLEN_LOST_CARD:
        'បដិសេធ - កាតត្រូវបានលួច ឬបាត់។ យោងតាមប្រតិបត្តិការទៅកាន់មជ្ឈមណ្ឌលជំនួយអតិថិសម្រាប់ការត្រួតពិនិត្យដោយដៃ។',
    DECLINED_ISSUER_UNAVAILABLE:
        'បដិសេធ - ការចេញធនាគារមិនអាចប្រើបានទេ។ រង់ចាំពីរទៅបីនាទី ហើយផ្ញើសំណើឡើងវិញ។',
    DECLINED_UNAUTHORIZED_CARD:
        'បដិសេធ - កាតអសកម្ម ឬកាតមិនត្រូវបានអនុញ្ញាតសម្រាប់ប្រតិបត្តិការកាតដែលមិនមានវត្តមាន។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_CVN_NOT_MATCH:
        'បដិសេធ - លេខផ្ទៀងផ្ទាត់កាត (CVN) មិនត្រូវគ្នាទេ។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_EXCEEDS_CREDIT_LIMIT:
        'បដិសេធ - កាតបានឈានដល់ដែនកំណត់ឥណទាន។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_INVALID_CVN:
        'បដិសេធ - លេខ​ផ្ទៀងផ្ទាត់កាតមិនត្រឹមត្រូវនឹងលេខ(CVN) ។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    DECLINED_DECLINED_CHECK:
        'បដិសេធ - បដិសេធទូទៅ។ ស្នើសុំទម្រង់នៃការបង់ប្រាក់ផ្សេងទៀត។',
    DECLINED_BLACKLISTED_CUSTOMER:
        'បដិសេធ - អតិថិជន​ត្រូវជាមួយនិង​ការកំនត់ចូលអ្នក​ដំនើរការឯកសារអវិជ្ជមាន។ ពិនិត្យមើលការបញ្ជាទិញ ហើយទាក់ទងអ្នកដំណើរការការទូទាត់។',
    DECLINED_SUSPENDED_ACCOUNT:
        'បដិសេធ - គណនីរបស់អតិថិជនត្រូវបានបង្កក។ ពិនិត្យមើលការបញ្ជាទិញ ឬស្នើសុំទម្រង់បង់ប្រាក់ផ្សេង។',
    DECLINED_INVALID_ACCOUNT:
        'បដិសេធ - លេខគណនីមិនត្រឹមត្រូវ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    INVALID_REQUEST_CARD_TYPE_NOT_ACCEPTED:
        'បដិសេធ - ប្រភេទកាតមិនត្រូវបានទទួលយកដោយអ្នកដំណើរការការទូទាត់ទេ។ ទាក់ទងទៅធនាគារពាណិជ្ជរបស់អ្នក ដើម្បីបញ្ជាក់ថាគណនីរបស់អ្នកត្រូវបានបង្កើតឡើង ដើម្បីទទួលបានកាតដែលមានក្នុងសំណើរ។',
    DECLINED_GENERAL_DECLINE:
        'បដិសេធ - បដិសេធទូទៅដោយអ្នកដំនើរការ។ ស្នើសុំកាត ឬ ទម្រង់នៃការទូទាត់ប្រាក់ផ្សេងទៀត។',
    INVALID_REQUEST_PROCESSOR_UNAVAILABLE:
        'បដិសេធ - ដំណើរការបរាជ័យ។ រង់ចាំពីរទៅបីនាទី ហើយផ្ញើសំណើឡើងវិញ។',
    INVALID_REQUEST_INVALID_CARD_TYPE:
        'បដិសេធ - ប្រភេទកាតដែលបានផ្ញើមិនត្រឹមត្រូវ ឬមិនទាក់ទងជាមួយលេខប័ណ្ណឥណទាន។ បញ្ជាក់​ថា​ប្រភេទ​កាត​ទាក់ទងជាមួយ​លេខ​កាត​ឥណទាន​ដែល​បាន​បញ្ជាក់​ក្នុង​សំណើ​ ​,បន្ទាប់​មក​ផ្ញើ​សំណើ​ម្ដង​ទៀត។',
    CHECKOUT_REACHED_LIMIT_PURCHASE_SERVICE:
        'អ្នកប្រើប្រាស់ម្នាក់ៗអាចមាន Baby Cloud សកម្មចំនួន 10 ជាអតិបរមា។ សូមជាវយកកញ្ចប់ផ្សេងទៀត ហើយយក Baby Cloud ចេញពីរទេះរបស់អ្នក។',
    PAYMENT_INTENT_AUTHENTICATION_FAILURE:
        'យើងមិនអាចផ្ទៀងផ្ទាត់វិធីបង់ប្រាក់របស់អ្នកបានទេ។ សូមជ្រើសរើសវិធីបង់ប្រាក់ផ្សេង ហើយព្យាយាមម្តងទៀត',
    INVALID_SUBDOMAIN: 'សូម​បញ្ចូល​ដែន​រង​ដែល​ត្រឹមត្រូវ។',
    REQUIRED_DOMAIN: 'សូមបញ្ចូលឈ្មោះដែន',
    CLOUD_HOSTING_IS_SETTING_UP: 'Cloud Hosting គឺកំពុងរៀបចំ',
    MAX_PASSWORD_REGISTER:
        'ឈ្ពាក្យសម្ងាត់ប្រាស់ត្រូវតែមានចាប់ពី {from} ដល់ {to} តួអក្សរ',
    SAME_PASSWORD_REGISTER:
        'Oops, that’s not the same password as the first one.',
    INVALID_PASSWORD:
        'ឈ្ពាក្យសម្ងាត់មិនត្រឹមត្រូវ ពាក្យសម្ងាត់ទទួលយកតែអក្ខរក្រម លេខ និងតួអក្សរពិសេសប៉ុណ្ណោះ។',
    INVALID_PASSWORD_REGISTER:
        'ពាក្យសម្ងាត់ត្រូវតែមានយ៉ាងហោចណាស់អក្សរធំមួយ អក្សរតូចមួយ លេខមួយ',
    DOWNLOAD_AN_SSL_CERTIFICATE_FAILED: 'ការទាញយកវិញ្ញាបនប័ត្របានបរាជ័យ។',
    EMAIL_NOT_CHANGE: 'អ៊ីមែលថ្មីមិនខុសពីអ៊ីមែលបច្ចុប្បន្នទេ',
    ACTIVITY_LOG_NOT_FOUND: 'រកមិនឃើញកំណត់ហេតុនៃការចូលប្រេីប្រាស់',
    INVALID_CLOUD_SERVER_JOB_STATUS:
        'ស្ថានភាពការងារ Cloud Server មិនត្រឹមត្រូវ',
    ENABLED_BACKUP_CLOUD_SERVER:
        'ការបម្រុងទុករបស់ Cloud Server ត្រូវបានបើកដំណើរការ',
    DISABLED_BACKUP_CLOUD_SERVER: 'ការបម្រុងទុករបស់ Cloud Server ត្រូវបានបិទ',
    BACKUP_UNAVAILABLE: 'មុខងារបម្រុងទុកបច្ចុប្បន្នមិនអាចប្រើបានទេ។',
    TRIAL_SMS_CONTENT_NOT_EXIST:
        'មាតិកា SMS សាកល្បងប្រើប្រាស់ គឺមិនមានទេ។ សម្រាប់ជំនួយបន្ថែម សូមទាក់ទងទៅកាន់អ្នកគ្រប់គ្រង។',
    TRIAL_BRANDNAME_INVALID:
        'ឈ្មោះម៉ាកយីហ៊ោ គឺមិនមានទេ។ សម្រាប់ជំនួយបន្ថែម សូមទាក់ទងទៅកាន់អ្នកគ្រប់គ្រង។',
    USED_TRIAL_SMS_SERVICE: 'អ្នកបានប្រើសារ SMS សាកល្បង',
    DOMAIN_NOT_SUPPORT: 'ដែនមិនគាំទ្រ',
    SYSTEM_BUSY: 'ប្រព័ន្ធកំពុងតែជាប់រវល់, សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ',
    DOMAIN_CANNOT_REACTIVATED: 'ដែនមិនអាចដំណើរការឡើងវិញបានទេ',
    PACKAGE_NOT_SUPPORT_UPGRADE: 'កញ្ចប់មិនត្រូវបានគាំទ្រដើម្បីដំឡើងកំណែទេ។',
    CANNOT_INSTALL_SSL_FOR_DOMAIN: 'វិញ្ញាបនបត្រទាំងនេះមិនត្រឹមត្រូវទេ',
    CLOUD_STATUS_INVALID:
        'ស្ថានភាព​ Cloud របស់អ្នកបច្ចុប្បន្នមិនអាចអនុវត្តសកម្មភាពនេះបានទេ',
    LINKED_ACCOUNT_ALREADY_EXISTS:
        'អាសយដ្ឋានអ៊ីមែលនេះត្រូវបានភ្ជាប់ជាមួយគណនី 1Byte រួចហើយ',
    OMISE: {
        CONFIRMED_AMOUNT_MISMATCH:
            'Payment Gateway Error: Final amount from payment channel does not match original amount charged',
        FAILED_FRAUD_CHECK:
            'Payment Gateway Error: Card was marked as fraudulent',
        FAILED_PROCESSING:
            'Payment Gateway Error: General payment processing failure',
        INSUFFICIENT_BALANCE:
            'Payment Gateway Error: Insufficient funds in the account or the card has reached the credit limit',
        INSUFFICIENT_FUND:
            'Payment Gateway Error: Insufficient funds in the account or the card has reached the credit limit',
        INVALID_ACCOUNT_NUMBER:
            'Payment Gateway Error: Valid account for payment method not found',
        INVALID_ACCOUNT:
            'Payment Gateway Error: Valid account for payment method not found',
        PAYMENT_CANCELLED: 'Payment Gateway Error: Payment cancelled by payer',
        PAYMENT_REJECTED: 'Payment Gateway Error: Payment rejected by issuer',
        STOLEN_OR_LOST_CARD: 'Payment Gateway Error: Card stolen or lost',
        TIMEOUT:
            'Payment Gateway Error: Payment provider did not respond in time',
        OMISE_SERVICE_ERROR:
            'Payment Gateway Error: Please try again, if this still happens, please contact support',
        INVALID_CHARGE: 'Payment Gateway Error: {message}',
    },
    CARD_MONTHLY_LIMIT_EXCEEDED:
        'ចំនួននៃការបង់ប្រាក់លើសពីដែនកំណត់ប្រចាំខែនៃកាតរបស់អ្នក',
    CONTRACT_NOT_FOUND: 'កិច្ចសន្យាមិនត្រូវបានរកឃើញ',
};
